import { ChangeDetectorRef, Component } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ConnectionsService } from '../../../services/connectionsWeb3/connections.service';
import Swal from 'sweetalert2';
import * as jsonManager from '../../../abis/Manager.json';
import * as jsonToken from '../../../abis/TokenHoldings.json';
import * as jsonSeller from '../../../abis/Seller.json';
import * as jsonErc20 from '../../../abis/ERC20.json';
import { environment } from '../../../../environments/environment';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { HttpClient } from '@angular/common/http';
import { ProjectStatusTransitionsService } from '../../../services/project-status-transitions.service';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';

@Component({
  selector: 'app-add-dividends',
  templateUrl: './add-dividends.component.html',
  styleUrls: ['./add-dividends.component.css']
})
export class AddDividendsComponent {
  ourAddress: string | undefined;
  web3: any | undefined;
  abiManager: any = jsonManager;
  abiToken: any = jsonToken;
  abiSeller: any = jsonSeller;
  abiErc20: any = jsonErc20;
  contractManager: any | undefined;
  formAddDividends: FormGroup = this.createFormDividends();
  formAddDividendsFiat: FormGroup = this.createFormDividendsFiat();
  retentionsTokens: number = 0;
  retentionsTokensCompany: number = 0;
  selectedForm: string = 'blockchain';
  contractAddress: string = '';
  existsProject: boolean = false;
  // imageURL:string = "https://firebasestorage.googleapis.com/v0/b/domoblock-devnew.appspot.com/o/investments%2F1705674582557%2FAjustada.jpg?alt=media&token=af53ba29-b974-442d-b1ae-ea0cf31b5a52"
  imageURL:string = ''
  amountSold:number = 0;
  amountSoldWithBonus:number = 0;
  annualReturn:string = ""
  title:string = ""
  description:string = ""
  totalAmountMangopay:number = 0;
  totalAmountMangopayWithoutBonus:number = 0;
  totalPrivateSaleBonusApplied:number = 0;
  totalAmountMangopayGross:number = 0;
  retentionApplied:number = 0;
  usersRetentionData:any;
  totalInvested: number = 0;
  privateSaleBonusTotal: number = 0;
  retentionMangopay: boolean = false;
  totalRaw: number = 0;
  distributionPercentage: number = 100;
  grossDividendInput: number = 0;
  dividendSelected: string = 'Renta';
  dividendTypes = ['Renta','Venta'];
  lastDividend: boolean = false;
  useMultiProperty: boolean = false;
  // projectId: any;
  private apiUrl = environment.api.url;
  availableProjects: any[] = [];
  isLoadingProjects: boolean = false;
  userData: any;

  constructor(
    private http: HttpClient,
    private connSrv: ConnectionsService, 
    private afs: AngularFirestore, 
    private fns: AngularFireFunctions, 
    private crf: ChangeDetectorRef,
    private statusTransitionsService: ProjectStatusTransitionsService
  ) {
    this.web3 = this.connSrv.web3Instance;

    this.connSrv.addressUser.subscribe((res: string) => { 
      this.ourAddress = res;
    });

    this.contractManager = new this.web3.eth.Contract(this.abiManager.abi, environment.config.ADDRESS_MANAGER); 
    this.loadAvailableProjects();
  }

  async loadAvailableProjects() {
    this.isLoadingProjects = true;
    try {
      // Primero intentamos obtener desde la API
      this.http.get(`${this.apiUrl}/projects`).subscribe({
        next: (projects: any) => {
          const allProjects = Array.isArray(projects) ? projects : projects.data || [];
          // Mostrar todos los proyectos con su estado
          this.availableProjects = allProjects.filter((project: any) => 
            project.tokensAddress && (project.status || project.proyectStatus)
          );
          this.isLoadingProjects = false;
        },
        error: () => {
          // Si falla la API, obtenemos desde Firestore
          this.getProjectsFromFirestore();
        }
      });
    } catch (error) {
      // Si hay error, obtenemos desde Firestore
      this.getProjectsFromFirestore();
    }
  }

  getProjectsFromFirestore() {
    this.afs.collection('investments', ref => 
      ref.where('tokensAddress', '!=', null)
    ).get().subscribe({
      next: (snapshot) => {
        this.availableProjects = [];
        snapshot.forEach((doc) => {
          const data = doc.data() as any;
          if (data.tokensAddress) {
            this.availableProjects.push({
              id: doc.id,
              title: data.title || 'Proyecto sin título',
              tokensAddress: data.tokensAddress,
              description: data.description || '',
              status: data.proyectStatus
            });
          }
        });
        this.isLoadingProjects = false;
      },
      error: (error) => {
        console.error('Error loading projects from Firestore:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudieron cargar los proyectos disponibles'
        });
        this.isLoadingProjects = false;
      }
    });
  }

  createFormDividends() {
    return new FormGroup({
      selectedProject: new FormControl(null, [Validators.required]),
      tokenAddress: new FormControl(null, [Validators.required]),
      amount: new FormControl(null, [Validators.required]),
      retentionFlag: new FormControl(null, [Validators.required]),
      priceStableCoin: new FormControl(null, [Validators.required]),
      finishFlag: new FormControl(null, [Validators.required])
    })
  }
  createFormDividendsFiat() {
    return new FormGroup({
      projectId:new FormControl(null, [Validators.required])
    })
  }

  get selectedProject() { return this.formAddDividends?.get('selectedProject'); }
  get tokenAddress() { return this.formAddDividends?.get('tokenAddress'); }
  get amount() { return this.formAddDividends?.get('amount'); }
  get retentionFlag() { return this.formAddDividends?.get('retentionFlag'); }
  get priceStableCoin() { return this.formAddDividends?.get('priceStableCoin'); }
  get finishFlag() { return this.formAddDividends?.get('finishFlag'); }
  get projectId() { return this.formAddDividendsFiat?.get('projectId'); }

  onProjectSelected(event: any) {
    const selectedTokenAddress = event.target.value;
    const selectedProject = this.availableProjects.find(p => p.tokensAddress === selectedTokenAddress);
    
    if (selectedProject && selectedTokenAddress) {
      // Actualizamos el campo tokenAddress automáticamente
      this.formAddDividends.patchValue({
        tokenAddress: selectedTokenAddress
      });
      
      console.log('Proyecto seleccionado:', selectedProject.title, 'Dirección:', selectedTokenAddress);
    } else {
      // Si no hay proyecto seleccionado, limpiamos el campo tokenAddress
      this.formAddDividends.patchValue({
        tokenAddress: null
      });
    }
  }


  async addDividends() {
    if (this.formAddDividends.invalid) { 
      this.formAddDividends.markAllAsTouched();
      return; 
    }

    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    this.afs.collection('investments', ref => ref.where('tokensAddress', '==', this.tokenAddress?.getRawValue()).limit(1)).get().subscribe(async (snapDocs: any) => {
      const data: any = snapDocs.docs[0].data();

      const idProyect: string = data.id;
      const stableCoinAddress: string = data.stableCoinAddress;
      const dividendsAddress: string = data.dividendsAddress;

      const contractToken: any = new this.web3.eth.Contract(this.abiToken.abi, this.tokenAddress?.getRawValue());       

      const balanceSeller: number = await contractToken.methods.balanceOf(data.sellerAddress).call();
      if (balanceSeller > 0) {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Erro en contrato',
          text: 'No se han vendido todos los tokens'
        });

        return;
      }

      const _currentIdSnapshot: number = Number(await contractToken.methods.getCurrentSnapshotId().call());
      const currentIdSnapshot: string = String(_currentIdSnapshot + 1); 

      this.fns.httpsCallable('newSnapshot')({token: this.tokenAddress?.getRawValue(), idSnapshot: _currentIdSnapshot + 1}).subscribe((res:any) =>{
        if (!res.success) {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Fallo en la base de datos'
          });
  
          return;
        } else {
          this.afs.collection(`w-invest`).doc(this.tokenAddress?.getRawValue()).collection(currentIdSnapshot).get().subscribe(async (snapDocs: any) => {
            this.retentionsTokens = 0;
            this.retentionsTokensCompany = 0;
            debugger;
            // Obtener la retención general y preparar flag una sola vez
            const retentionsDoc: any = await firstValueFrom(this.afs.collection('retentions').doc("LQzvCF9iJq0EK0V52mOf").get());
            const generalRetention: number = Number(retentionsDoc.data()?.General ?? 0);
            const applyRetention: boolean = this.retentionFlag?.getRawValue() === true || this.retentionFlag?.getRawValue() === 'true';

            // Recopilar todos los valores y los userIds únicos en una sola pasada
            const allValues: any[] = [];
            for (const doc of snapDocs.docs) {
              if (doc.exists) {
                allValues.push(...Object.values(doc.data()));
              }
            }
            const uniqueUserIds: string[] = [...new Set(allValues.map((v: any) => v.user).filter(Boolean))];

            // Obtener todos los documentos de usuario en paralelo
            const userDocs = await Promise.all(
              uniqueUserIds.map((uid: string) => firstValueFrom(this.afs.collection('users').doc(uid).get()))
            );

            // Construir un Map uid → retentionPercentage para lookups O(1)
            const userRetentionMap = new Map<string, number>();
            for (let i = 0; i < uniqueUserIds.length; i++) {
              const user = (userDocs[i] as any).data();
              const isEmpresa = user != null && 'Empresa' in user;
              const rawRetention = isEmpresa
                ? user?.Empresa?.Datos_Empresa?.retentionPercentage
                : user?.particular?.retentionPercentage;
              userRetentionMap.set(uniqueUserIds[i], rawRetention != null ? Number(rawRetention) : generalRetention);
            }

            // Calcular retenciones sin más llamadas async
            for (const v of allValues) {
              const userRetention: number = userRetentionMap.get(v.user) ?? generalRetention;
              if (v.walletByCompany === false && applyRetention && v.percentRetentionTo > 0) {
                this.retentionsTokens += this.formatToEther(v.balance) * (userRetention / 100);
              }
              if (v.walletByCompany === true && applyRetention && v.percentRetentionTo > 0) {
                this.retentionsTokensCompany += this.formatToEther(v.balance) * (userRetention / 100);
              }
            }
    
            const totalSupply: number = this.formatToEther(await contractToken.methods.totalSupply().call());
            const totalByCompany: number = this.formatToEther(await contractToken.methods.amountBuyWithFiat().call());
            const tokensSC: number = (totalSupply - totalByCompany) - this.retentionsTokens;
            const tokensCompany: number = totalByCompany - this.retentionsTokensCompany;
    
            const percentSC: number = (tokensSC * 100) / totalSupply;
            const amountToTransfer: number = this.amount?.getRawValue() * (percentSC / 100);
            const amountWeisToTransfer: number = this.formatToWei(amountToTransfer);
    
            const percentCompany: number = (tokensCompany * 100) / totalSupply;
            const amountToTransferCompany: number = this.amount?.getRawValue() * (percentCompany / 100);
    
            const contractStableCoin: any = new this.web3.eth.Contract(this.abiErc20.abi, stableCoinAddress); 

            const baseFee: number = await this.web3.eth.getBlock('pending').then((block: any) => { 
              return Number(block.baseFeePerGas) + 100000000000; 
            });
    
            await contractStableCoin.methods.approve(dividendsAddress, amountWeisToTransfer).send({from: this.ourAddress, maxFeePerGas: this.web3.utils.toHex(baseFee), maxPriorityFeePerGas: this.web3.utils.toHex(this.web3.utils.toWei('50', 'gwei'))})
              .then(async () => {
                await this.contractManager.methods.addDividends(
                  this.ourAddress,
                  this.tokenAddress?.getRawValue(),
                  amountWeisToTransfer,
                  new Date().getFullYear(),
                  applyRetention
                ).send({from: this.ourAddress, maxFeePerGas: this.web3.utils.toHex(baseFee), maxPriorityFeePerGas: this.web3.utils.toHex(this.web3.utils.toWei('50', 'gwei'))})
                  .then(async () => {
                    this.afs.collection('snapshots').doc(this.tokenAddress?.getRawValue()).set({
                      [currentIdSnapshot]: {
                        snapShotId: currentIdSnapshot,
                        totalAmount: this.amount?.getRawValue(),
                        amountTransfered: amountToTransfer,
                        amountToTransferByCompany: amountToTransferCompany,
                        retentions: this.amount?.getRawValue() - (amountToTransfer + amountToTransferCompany),
                        addressStableCoin: stableCoinAddress,
                        priceStableCoin: this.priceStableCoin?.getRawValue(),
                        timeStamp: Date.now()
                      }
                    }, {merge: true});
        
                    if (this.finishFlag?.getRawValue() !== true) {
                      // Usar el servicio de transiciones para registrar el cambio
                      await this.statusTransitionsService.recordStatusTransition(
                        idProyect,
                        'Repartiendo dividendos',
                        'Dividendos agregados',
                        'admin'
                      );

                      Swal.close();
                      Swal.fire({
                        icon: 'success',
                        text: 'Ingreso realizado con éxito' 
                      });
                    } else {
                      // Usar el servicio de transiciones para registrar el cambio
                      await this.statusTransitionsService.recordStatusTransition(
                        idProyect,
                        'Vendido',
                        'Dividendos finales agregados',
                        'admin'
                      );
                      
                      Swal.close();
                      Swal.fire({
                        icon: 'info',
                        title: 'IMPORTANTE',
                        text: 'Ingreso realizado con éxito, pero tienes que pausar este contrato en la administración'
                      });
                    }
    
                    this.formAddDividends.reset();
                  })
                  .catch(() => {
                    Swal.close();
                    Swal.fire({
                      icon: 'error',
                      title: 'Transacción errónea',
                      text: 'Algo ha ido mal, la transacción de para insertar los divididendos NO se ha realizado'
                    });
                  });
              })
              .catch(() => {
                Swal.close();
                Swal.fire({
                  icon: 'error',
                  title: 'Transacción errónea',
                  text: 'Algo ha ido mal, la transacción de approve NO se ha realizado'
                });
              });
          });
        }
      });
    });
  }

  formatToEther(num: number) {
    const BN = this.web3.utils.BN;

    try {
      return this.web3.utils.fromWei(new BN(num).toString(), 'ether');
    } catch (error) {
      return this.web3.utils.fromWei(num.toString(), 'ether');
    }
  }

  showForm(formType: string) {
    this.selectedForm = formType;
}

  formatToWei(num: number) {
    return this.web3.utils.toWei(num.toString(), 'ether');
  }

  getProjectData(){
    console.log(this.contractAddress)
    if(!this.contractAddress){
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se ha seleccionado un proyecto'
      });
      this.existsProject = false;
      return;
    }
    //https://domoback-mangopay.devmitsoftware.com
    this.http.get(`${this.apiUrl}/projects/${this.contractAddress}`).subscribe({
      next:(data:any)=>{
        this.existsProject = true;
        this.title = data?.title as string;
        this.imageURL = data?.image as string;
        this.amountSold = Number(data?.balance || 0)/100;
        this.amountSoldWithBonus = Number(data?.balanceWithPrivateSaleBonus ?? data?.balance ?? 0)/100;
        this.description = data?.description as string;
        this.privateSaleBonusTotal = Number(data?.privateSaleBonusTotal || 0)/100;
        this.totalAmountMangopay = 0;
        this.totalAmountMangopayWithoutBonus = 0;
        this.totalPrivateSaleBonusApplied = 0;
        this.totalInvested = Number(data?.totalInvested || 0)/100;
        this.usersRetentionData = data?.amountCollectedData;
        this.userData = [];
    },
    error:(error)=>{
      console.log(error.message)
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No hay proyectos con este contrato'
      });
      this.existsProject = false;
    }
    }
   )
  }

  createDividends(){
    // Validar que exista un proyecto
    if (!this.existsProject || !this.contractAddress) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debes seleccionar un proyecto válido'
      });
      return;
    }

    // Validar que se haya calculado el total
    if (!this.userData || this.userData.length === 0 || this.totalAmountMangopay <= 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Debes introducir un monto válido para calcular los dividendos'
      });
      return;
    }

    // Validar porcentaje de distribución solo si se usa multipropiedad
    if (this.useMultiProperty && (this.distributionPercentage <= 0 || this.distributionPercentage > 100)) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'El % a repartir debe estar entre 0.01 y 100'
      });
      return;
    }

    // Determinar el porcentaje a enviar: 100 si no usa multipropiedad, el valor ingresado si sí
    const finalPercentage = this.useMultiProperty ? this.distributionPercentage : 100;

    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
    //https://domoback-mangopay.devmitsoftware.com
    this.http.post(`${this.apiUrl}/projects/dividends/create`,{
      address: this.contractAddress,
      amount: this.totalRaw * 100,
      retention: this.retentionMangopay,
      totalMangopay: this.amountSold,
      totalTransfer: Number(this.totalAmountMangopay),
      lastDividend: this.lastDividend,
      proyectStatus: this.lastDividend ? 'Vendido' : 'Repartiendo dividendos',
      userData: this.userData,
      distributionPercentage: finalPercentage,
      dividendType: this.dividendSelected
    }).subscribe({
      next:()=>{
        Swal.close()
        Swal.fire({
          icon:'success',
          title: 'Dividendos generados con éxito',
          text: 'Los dividendos han sido generados correctamente'
        })
      },
      error:(e)=>{
        console.log(e)
        Swal.close()
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al crear los dividendos, verifique el saldo introducido'
        })
      }
    })
  }

  private resetCalculatedTotals(): void {
    this.totalAmountMangopay = 0;
    this.totalRaw = 0;
    this.userData = [];
    this.totalAmountMangopayWithoutBonus = 0;
    this.totalPrivateSaleBonusApplied = 0;
    this.totalAmountMangopayGross = 0;
    this.retentionApplied = 0;
  }

  onDistributionPercentageChange(rawValue: string | number): void {
    const parsedPercentage = Number(rawValue);
    
    if (isNaN(parsedPercentage) || rawValue === null || rawValue === undefined || rawValue === '') {
      this.distributionPercentage = 100;
      this.sumTotal(); // Recalcular con el valor por defecto
      return;
    }
    
    // Limitar el rango entre 0.01 y 100
    if (parsedPercentage < 0.01) {
      this.distributionPercentage = 0.01;
    } else if (parsedPercentage > 100) {
      this.distributionPercentage = 100;
    } else {
      this.distributionPercentage = parsedPercentage;
    }
    
    // Siempre recalcular cuando cambia el porcentaje
    this.sumTotal();
  }

  onLastDividendChange(): void {
    if (this.lastDividend) {
      let timerInterval: any;
      let secondsLeft = 5;
      
      Swal.fire({
        icon: 'warning',
        title: '⚠️ Advertencia',
        html: `
          <p style="font-size: 1em; margin-bottom: 15px;">
            <strong>Has marcado este reparto como el último del proyecto.</strong>
          </p>
          <p style="font-size: 0.95em; color: #666; text-align: left; margin-bottom: 10px;">
            Esto significa que:
          </p>
          <ul style="text-align: left; color: #666; font-size: 0.9em; line-height: 1.8;">
            <li>El proyecto se marcará como <strong style="color: #e74c3c;">"Vendido"</strong></li>
            <li>No se podrán realizar más repartos de dividendos</li>
            <li>El proyecto aparecerá como finalizado para los inversores</li>
          </ul>
          <p style="font-size: 0.95em; color: #ff9600; margin-top: 15px;">
            <strong>¿Estás seguro de querer continuar?</strong>
          </p>
          <p id="timer-text" style="font-size: 0.9em; color: #999; margin-top: 15px;">
            Por favor, lee cuidadosamente. Podrás confirmar en <strong id="timer-seconds">5</strong> segundos...
          </p>
        `,
        showCancelButton: true,
        confirmButtonColor: '#e74c3c',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Sí, es el último reparto',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        didOpen: () => {
          const confirmButton = Swal.getConfirmButton();
          if (confirmButton) {
            confirmButton.disabled = true;
            confirmButton.style.opacity = '0.5';
            confirmButton.style.cursor = 'not-allowed';
          }
          
          timerInterval = setInterval(() => {
            secondsLeft--;
            const timerElement = document.getElementById('timer-seconds');
            if (timerElement) {
              timerElement.textContent = secondsLeft.toString();
            }
            
            if (secondsLeft <= 0) {
              clearInterval(timerInterval);
              const timerText = document.getElementById('timer-text');
              if (timerText) {
                timerText.style.display = 'none';
              }
              if (confirmButton) {
                confirmButton.disabled = false;
                confirmButton.style.opacity = '1';
                confirmButton.style.cursor = 'pointer';
              }
            }
          }, 1000);
        },
        willClose: () => {
          if (timerInterval) {
            clearInterval(timerInterval);
          }
        }
      }).then((result) => {
        if (!result.isConfirmed) {
          this.lastDividend = false;
        }
      });
    }
  }

  onDividendTypeChange(): void {
    // Si el tipo de dividendo no es "Venta", desmarcar el checkbox de último reparto
    if (this.dividendSelected !== 'Venta') {
      this.lastDividend = false;
    }
    // Recalcular totales
    this.sumTotal();
  }

  sumTotal(rawValue?: string | number): void {
    const parsedValue = rawValue !== undefined ? Number(rawValue) : this.grossDividendInput;

    // Validar el monto introducido
    if (isNaN(parsedValue)) {
      this.resetCalculatedTotals();
      return;
    }

    if (parsedValue < 0) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'El importe no puede ser negativo'
      });
      this.resetCalculatedTotals();
      return;
    }

    // Si el valor es 0 o vacío, simplemente resetear
    if (parsedValue === 0) {
      this.resetCalculatedTotals();
      return;
    }

    this.grossDividendInput = parsedValue;

    // Validar porcentaje de distribución
    // Si no usa multipropiedad, siempre usar 100%
    const effectivePercentage = this.useMultiProperty ? this.distributionPercentage : 100;
    const distributionFactor = Number(effectivePercentage || 100) / 100;
    
    if (distributionFactor <= 0 || distributionFactor > 1) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'El % a repartir debe estar entre 0.01 y 100'
      });
      this.resetCalculatedTotals();
      return;
    }

    const amountSoldValue = Number(this.amountSold || 0);
    const totalInvestedValue = Number(this.totalInvested || 0);
    const aggregatedWalletAmount = (this.usersRetentionData || []).reduce((sum: number, item: any) => {
      return sum + Number(item?.amount || 0) / 100;
    }, 0);
    const effectiveAmountSold = amountSoldValue > 0 ? amountSoldValue : aggregatedWalletAmount;
    const effectiveTotalInvested = totalInvestedValue > 0 ? totalInvestedValue : effectiveAmountSold;

    const portionAmountSold = effectiveAmountSold * distributionFactor;
    const portionTotalInvested = effectiveTotalInvested * distributionFactor;

    if (portionAmountSold <= 0 || portionTotalInvested <= 0) {
      Swal.fire({
        icon: 'info',
        title: 'Datos insuficientes',
        text: 'No hay ventas registradas para calcular el dividendo de forma segura.'
      });
      this.resetCalculatedTotals();
      return;
    }

    const mangopayPercentage = portionAmountSold / portionTotalInvested;
    const totalToMangopay = parsedValue * mangopayPercentage;
    
    // IMPORTANTE: La interpretación del campo cambia según el tipo de dividendo:
    // - Para tipo "Venta": parsedValue es el RETORNO TOTAL (capital + ganancia)
    //   Ejemplo: Apartamento costó 200,000€, se vendió en 250,000€ → se introduce 250,000€
    //   Ganancia = 250,000€ - 200,000€ (capital) = 50,000€ (solo esto tiene retención)
    // - Para tipo "Renta": parsedValue es la GANANCIA pura (no hay devolución de capital)
    //   Ejemplo: 2,000€ de rentas → se introduce 2,000€ (todo tiene retención)
    const profit = this.dividendSelected === 'Venta' 
      ? totalToMangopay - portionAmountSold  // Restar capital para obtener ganancia
      : totalToMangopay;  // En renta, todo es ganancia

    if (isNaN(profit)) {
      this.resetCalculatedTotals();
      return;
    }

    this.totalRaw = profit;

    interface IUserTotals {
      user: string;
      amount: number;
      amountWithBonus: number;
      retention: number;
      totalDividend: number;
      grossInterestBase: number;
      grossInterest: number;
      netInterest: number;
      grossReturn: number;
      netReturn: number;
      netReturnWithoutBonus: number;
      privateSaleBonus: number;
      taxType: string;
      isPrivateSale: boolean;
    }

    const userTotals: Record<string, IUserTotals> = {};
    let totalWithoutBonus = 0;
    let totalNetBonus = 0;

    (this.usersRetentionData || []).forEach((y: any) => {
      const amountCents = Number(y?.amount || 0);
      
      // IMPORTANTE: Solo calcular bonus si es venta privada
      let bonusCents = 0;
      if (y?.isPrivateSale === true) {
        if (y?.bonus !== undefined && y?.bonus !== null) {
          // Si existe el campo bonus explícito, usarlo
          bonusCents = Number(y.bonus);
        } else if (y?.amountWithBonus !== undefined && y?.amountWithBonus !== null) {
          // Si existe amountWithBonus, calcular bonus como diferencia
          bonusCents = Math.max(Number(y.amountWithBonus) - amountCents, 0);
        } else {
          // Calcular 0.5% del monto como bonus estándar
          bonusCents = Math.round(amountCents * 0.005);
        }
      }
      // Si NO es venta privada, bonusCents queda en 0
      
      const amountEuros = (amountCents / 100) * distributionFactor;
      const bonusGross = (bonusCents / 100) * distributionFactor;
      const retention = Number(y?.retention || 0);
      const userId = y?.user ?? 'unknown';
      const baseParticipation = portionAmountSold ? amountEuros / portionAmountSold : 0;
      const grossInterestBase = profit * baseParticipation;
      const netInterestBase = this.retentionMangopay ? grossInterestBase * (1 - retention / 100) : grossInterestBase;
      const netBonus = this.retentionMangopay ? bonusGross * (1 - retention / 100) : bonusGross;
      const grossInterestWithBonus = grossInterestBase + bonusGross;
      const netInterestWithBonus = netInterestBase + netBonus;
      const grossReturnBase = this.dividendSelected == 'Venta' ? amountEuros + grossInterestBase : grossInterestBase;
      const grossReturnWithBonus =
        this.dividendSelected == 'Venta' ? amountEuros + grossInterestWithBonus : grossInterestWithBonus;
      const netReturnBase = this.dividendSelected == 'Venta' ? amountEuros + netInterestBase : netInterestBase;
      const netReturn = netReturnBase + netBonus;
      const taxType = this.retentionMangopay
        ? (retention > 0 ? `Retención ${retention}%` : 'Sin retención')
        : 'No aplica';

      totalWithoutBonus += netReturnBase;
      totalNetBonus += netBonus;

      if (!userTotals[userId]) {
        userTotals[userId] = {
          user: userId,
          amount: 0,
          amountWithBonus: 0,
          retention,
          totalDividend: 0,
          grossInterestBase: 0,
          grossInterest: 0,
          netInterest: 0,
          grossReturn: 0,
          netReturn: 0,
          netReturnWithoutBonus: 0,
          privateSaleBonus: 0,
          taxType,
          isPrivateSale: Boolean(y?.isPrivateSale),
        };
      }

      userTotals[userId].amount += amountEuros;
      userTotals[userId].amountWithBonus += amountEuros + bonusGross;
      userTotals[userId].grossInterestBase += grossInterestBase;
      userTotals[userId].grossInterest += grossInterestWithBonus;
      userTotals[userId].netInterest += netInterestWithBonus;
      userTotals[userId].grossReturn += grossReturnWithBonus;
      userTotals[userId].netReturn += netReturn;
      userTotals[userId].netReturnWithoutBonus += netReturnBase;
      userTotals[userId].privateSaleBonus += netBonus;
      userTotals[userId].totalDividend += netReturn;
      userTotals[userId].retention = retention;
      userTotals[userId].taxType = taxType;
      userTotals[userId].isPrivateSale = Boolean(y?.isPrivateSale);
    });

    const userTotalsArray = Object.values(userTotals);
    const totalWithoutBonusRounded = Number(totalWithoutBonus.toFixed(2));
    const totalNetBonusRounded = Number(totalNetBonus.toFixed(2));

    // Calcular el total bruto (antes de retención) para comparación
    let totalGross = 0;
    (this.usersRetentionData || []).forEach((y: any) => {
      const amountCents = Number(y?.amount || 0);
      
      // IMPORTANTE: Solo calcular bonus si es venta privada (igual que el cálculo principal)
      let bonusCents = 0;
      if (y?.isPrivateSale === true) {
        if (y?.bonus !== undefined && y?.bonus !== null) {
          bonusCents = Number(y.bonus);
        } else if (y?.amountWithBonus !== undefined && y?.amountWithBonus !== null) {
          bonusCents = Math.max(Number(y.amountWithBonus) - amountCents, 0);
        } else {
          bonusCents = Math.round(amountCents * 0.005);
        }
      }
      
      const amountEuros = (amountCents / 100) * distributionFactor;
      const bonusGross = (bonusCents / 100) * distributionFactor;
      const baseParticipation = portionAmountSold ? amountEuros / portionAmountSold : 0;
      const grossInterestBase = profit * baseParticipation;
      const grossInterestWithBonus = grossInterestBase + bonusGross;
      const grossReturnWithBonus = this.dividendSelected == 'Venta' 
        ? amountEuros + grossInterestWithBonus 
        : grossInterestWithBonus;
      totalGross += grossReturnWithBonus;
    });

    this.totalAmountMangopayGross = Number(totalGross.toFixed(2));
    this.totalAmountMangopayWithoutBonus = totalWithoutBonusRounded;
    this.totalPrivateSaleBonusApplied = totalNetBonusRounded;
    this.totalAmountMangopay = Number((totalWithoutBonusRounded + totalNetBonusRounded).toFixed(2));
    this.retentionApplied = Number((this.totalAmountMangopayGross - this.totalAmountMangopay).toFixed(2));

    this.userData = userTotalsArray.map((total) => ({
      ...total,
      /** Capital invertido por el usuario en este reparto (sin bono de venta privada), en euros */
      amount: Number(total.amount.toFixed(2)),
      /** Capital invertido incluyendo el bono de venta privada, en euros */
      amountWithBonus: Number(total.amountWithBonus.toFixed(2)),
      /** Interés bruto puro: sin bono de venta privada y sin aplicar retención fiscal */
      grossInterestBase: Number(total.grossInterestBase.toFixed(2)),
      /** Interés bruto con bono de venta privada incluido, sin aplicar retención fiscal */
      grossInterest: Number(total.grossInterest.toFixed(2)),
      /** Interés neto con bono incluido, después de aplicar la retención fiscal */
      netInterest: Number(total.netInterest.toFixed(2)),
      /** Retorno bruto total: capital (si es Venta) + interés bruto con bono */
      grossReturn: Number(total.grossReturn.toFixed(2)),
      /** Retorno neto total: capital (si es Venta) + interés neto con bono, después de retención */
      netReturn: Number(total.netReturn.toFixed(2)),
      /** Retorno neto sin bono de venta privada: capital (si es Venta) + interés neto sin bono */
      netReturnWithoutBonus: Number(total.netReturnWithoutBonus.toFixed(2)),
      /** Importe neto del bono de venta privada después de aplicar la retención fiscal */
      privateSaleBonus: Number(total.privateSaleBonus.toFixed(2)),
      /** Importe total a transferir al usuario vía MangoPay (igual a netReturn) */
      totalDividend: Number(total.totalDividend.toFixed(2)),
    }));
  }

}
